import { tv } from "../../../variants/tv.js";
const tHeadVariants = tv({
    base: 'border-b-1 border-neutral-5 divide-neutral-5 divide-y',
    variants: {
        sticky: {
            true: 'z-2 sticky top-0'
        }
    },
    defaultVariants: {
        sticky: false
    }
});
export { tHeadVariants };
